import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-secondary-button',
  templateUrl: './secondary-button.component.html',
  styleUrls: ['./secondary-button.component.scss'],
  imports: [MatButton, NgClass],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class SecondaryButtonComponent {
  @Input() disabled = false;
  @Output() onClick = new EventEmitter();

  emitEvent() {
    if (this.disabled) return;
    this.onClick.emit();
  }
}
